import React, { ChangeEvent, useCallback, useState } from "react";
import { getLabelFromUserAccountRole } from "../../../../domain/user/account/UserAccountRole";
import { useAppDispatch } from "../../../../state/store";
import { keywordAndDateSearchAction } from "../../../../state/usecase/admin/login_log/actions";
import { useSearchedLoginLogList } from "../../../hooks/admin/login_log/useSearchedLoginLogList";
import { Button } from "../../common/button/Button";
import { SaveButton } from "../../common/button/SaveButton";
import { InputTextBox } from "../../common/input/InputTextBox";

export const LoginLogTableMenu = React.memo(function LoginLogTableSearch() {
    const dispatch = useAppDispatch();

    const { loginLogList } = useSearchedLoginLogList();

    const [keyword, setKeyword] = useState("");

    const [loginDateStart, setLoginDateStart] = useState("");
    
    const [loginDateEnd, setLoginDateEnd] = useState("");

    const saveCsv = useCallback(() => {
        const commaJoinedList = loginLogList.map((loginLog, index) => (
            `${index + 1},${loginLog.userName.value},${loginLog.email.value},${getLabelFromUserAccountRole(loginLog.role)},${loginLog.time.format()}`
        ));

        const indentionJoinedList = commaJoinedList.join("\n");

        const csv = new Blob([indentionJoinedList], { type: "text/csv" });

        const downloadLink = document.createElement("a");

        downloadLink.style.visibility = "hidden";

        downloadLink.href = URL.createObjectURL(csv);

        downloadLink.download = "ログイン履歴.csv";

        // Firefox では body の中にダウンロードリンクがないといけないので一時的に追加
        document.body.appendChild(downloadLink);

        downloadLink.click();

        // Firefox 対策で追加したリンクを削除しておく
        document.body.removeChild(downloadLink);
    }, [loginLogList]);

    const handleNameOrEmailCondition = useCallback((keyword: string) => {
        setKeyword(keyword);
    }, []);

    const handleLoginDateStart = useCallback((e: ChangeEvent<HTMLDataElement>) => {
        const startDate = e.target.value;
        setLoginDateStart(startDate);
    }, []);

    const handleLoginDateEnd = useCallback((e: ChangeEvent<HTMLDataElement>) => {
        const endDate = e.target.value;
        setLoginDateEnd(endDate);
    }, []);

    const handleSearchClick = useCallback(() => {
        if (loginDateStart && loginDateEnd && loginDateStart > loginDateEnd) {
            alert("ログイン日の開始と終了が逆転しています。");
            return;
        }

        dispatch(
            keywordAndDateSearchAction({
                keyword: keyword,
                loginDateStart: loginDateStart,
                loginDateEnd: loginDateEnd
            })
        );
    }, [dispatch, keyword, loginDateStart, loginDateEnd]);

    return (
        <div className={"table_menu"}>
            {/* 名前・メールアドレス、日付のフィルター */}
            <div className={"filter_input"}>
                {/* 名前・メールアドレス */}
                <div className={"name_or_email"}>
                    <span>フリーワード</span>
                    <InputTextBox value={keyword} handleTextChanged={handleNameOrEmailCondition} placeholder={"ユーザー名/メールアドレスで検索"} />
                </div>
                {/* ログイン日 */}
                <div className={"login_date"}>
                    <span>ログイン日</span>
                    <input type={"date"} value={loginDateStart} onChange={handleLoginDateStart} />
                    〜
                    <input type={"date"} value={loginDateEnd} onChange={handleLoginDateEnd} />
                </div>
                {/* 絞り込み実行 */}
                <div className={"search_button_area"}>
                    <Button label={"絞り込み"} onClick={handleSearchClick} />
                </div>
            </div>
            {/* csv保存 */}
            <SaveButton onClick={saveCsv} />
        </div>
    );
});